import PageTemplate from "../components/common/PageTemplate";
import DetailTransaction from "../screen/purchase/transaction/DetailTransaction";

const DetailTransactionPage = () => {
  return (
    <PageTemplate
      mainComponent={<DetailTransaction />}
      noPadding={true}
      logo="Detail Pesanan"
    />
  );
};

export default DetailTransactionPage;
